import { Button, VStack } from '@chakra-ui/react';
import { PartyFragment } from '@client/graphql/__generated__/types';
import { ADD_BUYER_FORM_ID, AddBuyerForm } from './AddBuyerForm/AddBuyerForm';
import { useAddBuyerForm } from './AddBuyerForm/hooks/useAddBuyerForm';
import { PartySelector } from './PartySelector/PartySelector';
import { SelectedPartyInfoForm } from './SelectedPartyInfo/SelectedPartyInfoForm';

interface AddOrEditBuyerProps {
  selectedParty?: PartyFragment;
  setSelectedParty: (party: PartyFragment | undefined) => void;
  showAddBuyerForm: boolean;
  setShowAddBuyerForm: (show: boolean) => void;
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
}

export const AddOrEditBuyer = ({
  selectedParty,
  setSelectedParty,
  showAddBuyerForm,
  setShowAddBuyerForm,
  isEditing,
  setIsEditing,
}: AddOrEditBuyerProps) => {
  const { buyerParties, loading, createParty, updateParty } = useAddBuyerForm({
    selectedParty,
    onSelectParty: setSelectedParty,
  });

  return (
    <VStack alignItems="stretch" flexGrow={1} spacing={4}>
      <PartySelector
        parties={buyerParties}
        selectedParty={selectedParty}
        setShowAddBuyerForm={setShowAddBuyerForm}
        showAddBuyerForm={showAddBuyerForm}
        onSelectParty={(party) => {
          if (party?.id) {
            setSelectedParty(party);
          } else {
            setSelectedParty(undefined);
          }
        }}
      />
      {showAddBuyerForm ? (
        <AddBuyerForm
          showFinancingInfo={true}
          onSubmit={async (values) => {
            // setIsLoading(true);
            await createParty(values);
            // setIsLoading(false);
            setShowAddBuyerForm(false);
            // buyerSelectProps.onCreateParty?.();
          }}
        />
      ) : undefined}
      {selectedParty ? (
        <SelectedPartyInfoForm
          handleSubmit={updateParty}
          isEditing={isEditing}
          party={selectedParty}
          setIsEditing={setIsEditing}
          showFinancingInfo={true}
        />
      ) : undefined}

      {showAddBuyerForm && (
        <Button form={ADD_BUYER_FORM_ID} isLoading={loading} type="submit">
          Add Buyer
        </Button>
      )}
    </VStack>
  );
};
